var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 35.236 36.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.353,29.526H6.87c-3.788,0-6.87-3.081-6.87-6.869V1.087C0,.486.486,0,1.087,0s1.087.486,1.087,1.087v21.57c0,2.589,2.106,4.695,4.696,4.695h8.483c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.099,17.818h-12.741c-2.281,0-4.137-1.855-4.137-4.137V5.337c0-2.257,1.835-4.093,4.092-4.093h3.933c.84,0,1.635.321,2.24.904l1.856,1.79c.197.19.457.295.73.295h4.027c2.281,0,4.137,1.856,4.137,4.138v5.311c0,2.281-1.856,4.137-4.137,4.137ZM18.313,3.418c-1.058,0-1.918.861-1.918,1.919v8.345c0,1.082.881,1.963,1.963,1.963h12.741c1.083,0,1.963-.881,1.963-1.963v-5.311c0-1.083-.881-1.964-1.963-1.964h-4.027c-.84,0-1.635-.321-2.24-.904l-1.856-1.79c-.197-.19-.457-.295-.73-.295h-3.933Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.099,36.57h-12.741c-2.281,0-4.137-1.856-4.137-4.138v-8.345c0-2.256,1.835-4.092,4.092-4.092h3.933c.84,0,1.635.321,2.24.904l1.856,1.79c.197.19.457.295.73.295h4.027c2.281,0,4.137,1.855,4.137,4.137v5.311c0,2.281-1.856,4.138-4.137,4.138ZM18.313,22.17c-1.058,0-1.918.86-1.918,1.918v8.345c0,1.083.881,1.964,1.963,1.964h12.741c1.083,0,1.963-.881,1.963-1.964v-5.311c0-1.082-.881-1.963-1.963-1.963h-4.027c-.84,0-1.635-.321-2.24-.904l-1.856-1.79c-.197-.19-.457-.295-.73-.295h-3.933Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.263,10.596H1.087c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h14.176c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFields);
export default __webpack_public_path__ + "static/media/Fields.6b1f72b7.svg";
export { ForwardRef as ReactComponent };